module.exports = __webpack_public_path__ + "static/img/learn_little_up_icon.d5208f7a.png";